import { Controller } from "@hotwired/stimulus";
import { Tooltip } from "bootstrap";

// Connects to data-controller="tooltip"
export default class extends Controller {
  static values = {
    state: String,
  };

  connect() {
    this.tooltip = Tooltip.getOrCreateInstance(this.element, {
      customClass: `tooltip-${this.stateValue || "default"}`,
    });

    if (this.element === document.activeElement) {
      this.tooltip.show();
    }
  }
}
